"use client";

import { cn } from "@/lib/utils";
import { type ComponentProps, memo } from "react";
import { Streamdown } from "streamdown";

type ResponseProps = ComponentProps<typeof Streamdown>;

export const Response = memo(
  ({ className, ...props }: ResponseProps) => {
    // Completely disable emphasis/italic rendering to prevent underscore issues
    const components = {
      ...props.components,
      // Render all emphasis as normal text
      em: ({ children }: any) => <span>{children}</span>,
      // Also handle strong (bold) just in case
      strong: ({ children }: any) => <strong>{children}</strong>,
    };

    return (
      <Streamdown
        className={cn(
          "size-full [&>*:first-child]:mt-0 [&>*:last-child]:mb-0",
          className,
        )}
        components={components}
        {...props}
      />
    );
  },
  (prevProps, nextProps) => prevProps.children === nextProps.children,
);

Response.displayName = "Response";
